module.exports = __webpack_public_path__ + "static/media/RBG_art_Shannon_Rollins.c1d24bf5.png";